export default "__VITE_ASSET__BhL2HqP4__"